import React from "react";

const TableCell = ({ children, nowrap }) => (
  <td className={`py-6 px-6 border-b border-grey-light ${nowrap && "whitespace-nowrap"}`}>{children}</td>
);

export default TableCell;
